import { render, staticRenderFns } from "./CTNotReading.AU.3.vue?vue&type=template&id=f15da2bc&scoped=true"
import script from "./CTNotReading.AU.3.vue?vue&type=script&lang=js"
export * from "./CTNotReading.AU.3.vue?vue&type=script&lang=js"
import style0 from "./CTNotReading.AU.3.vue?vue&type=style&index=0&id=f15da2bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15da2bc",
  null
  
)

export default component.exports